<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top>
            {{ text }}
            <v-btn color="pink" text @click="msg = false">Close</v-btn>
        </v-snackbar>
        <ClientNav />
        <v-container>
            <v-row dense>
                <v-col cols="12" md="3">
                    <ClientSide />
                </v-col>
                <v-col cols="12" md="9">
                    <v-card class="pa-2" outlined tile>
                        <v-form ref="form" lazy-validation>
                            <v-tabs v-model="tab" background-color="white" centered>
                                <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="tab">
                                <v-tab-item v-for="(item, i) in items" :key="item">
                                    <v-data-table
                                        :headers="headers"
                                        :items="i === 0 ? services : disabledServices"
                                        sort-by="StartDate"
                                        :loading="isLoading"
                                        loading-text="Loading Service Items..."
                                        :search="search"
                                        class="elevation-1"
                                    >
                                        <template v-slot:top>
                                            <v-toolbar flat>
                                                <v-toolbar-title>Service Plan</v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-text-field
                                                    v-model="search"
                                                    append-icon="mdi-magnify"
                                                    label="Search"
                                                    single-line
                                                    hide-details
                                                ></v-text-field>
                                                        <v-btn v-if="!isAuditorRole" color="primary" dark @click="showAdd">
                                                            Add Service Item
                                                        </v-btn>
                                            </v-toolbar>
                                        </template>
                                        <template v-slot:item.actions="{ item }">
                                            <v-icon small class="mr-2" @click="viewService(item)">
                                                mdi-eye
                                            </v-icon>
                                            <!-- <v-icon v-if="!isAuditorRole" small @click="deleteService(item)">
                                                mdi-delete
                                            </v-icon> -->
                                        </template>
                                    </v-data-table>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-form>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog
            v-model="serviceItemDialog"
            max-width="500px"
            transition="dialog-top-transition"
        >
            <v-card>
                <v-toolbar color="primary" dark>Add Service Item</v-toolbar>
                <v-card-text>
                    <v-form>
                        <v-text-field
                            label="Item Name*"
                            :rules="requiredField"
                            v-model="newServiceItemAdd"
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="serviceItemDialog = false">
                        Close
                    </v-btn>
                    <v-btn class="white--text" color="#259647" @click="addServiceItem()"
                    >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <Foot />
    </div>
</template>


<script>
/*eslint-disable */
import axios from "axios";
import ClientNav from "@/components/ClientNav";
import ClientSide from "@/components/ClientSide";
import Foot from "@/components/Footer";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import { setUserTz, tz, testTz } from "../../../../utils/timezone";
import { ValidationObserver, ValidationProvider } from "vee-validate";

const url = require("../../../client_config/config").url;

const MORNING = ["6:00am", "7:00am", "8:00am", "9:00am", "10:00am", "11:00am"];
const AFTERNOON = ["12:00pm", "1:00pm", "2:00pm", "3:00pm", "4:00pm", "5:00pm"];
const EVENING = [
  "6:00pm",
  "7:00pm",
  "8:00pm",
  "9:00pm",
  "10:00pm",
  "11:00pm",
  "12:00am",
  "1:00am",
  "2:00am",
  "3:00am",
  "4:00am",
  "5:00am",
];

export default {
  components: {
    ClientNav,
    ClientSide,
    Foot,
    ValidationProvider,
    ValidationObserver,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Start Date",
          align: "start",
          sortable: false,
          value: "StartDate",
          width: "15%",
        },
        { text: "Status", value: "Active" },
        { text: "Service Item", value: "ServiceItem" },
        { text: "Scheduled Time", value: "ScheduledTime" },
        { text: "Instructions", value: "Instructions", width: "40%" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      tab: null,
      items: ["Active Service Plan", "Disabled Service Plan"],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      menu2: false,
      dialog: false,
      editService: false,
      newService: false,
      msg: false,
      search: "",
      text: "",
      strategies: [],
      humanRights: [],
      HRC: "",
      habs: [],
      supportStrategy: "",
      habPlan: "",
      strategy: "",
      restriction: "",
      services: [],
      disabledServices: [],
      tempServices: [],
      codes: [],
      tempData: [],
      clientID: this.$route.params.clientID,
      type: ["Morning", "Afternoon", "Night"],
      /* serviceItems: ["Activities", "Attitude and Behavior", "Ambulation", "Bathing/Showering", "Bed Making", "Behavioral Management",
      "Breakfast", "Cleaning Bedroom", "Dinner", "Dressing", "Financial Management", "Grooming", "Hair", "Housekeeping",
      "Laundry", "Lunch", "Mobility", "Oral", "Reading", "Shave", "Toileting", "Education/Schooling", "Physical Fitness"],*/
      serviceItems: [],
      // provider: ["Behaviorist", "CNA", "Cook", "Direct Care Staff", "Housekeeper", "Nurse", "Program Manager", "Yard Maintenance"], //old provider list
      provider: [
        "Day Program Staff",
        "Direct Care Staff",
        "House Staff",
        "JDT Staff",
      ],
      status: ["Active", "Disabled"],
      loa: [
        "Independant",
        "Minimal Assistance",
        "Moderate Assistance",
        "Total Assistance",
      ],
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      scheduledTime: [
        "12:00am",
        "1:00am",
        "2:00am",
        "3:00am",
        "4:00am",
        "5:00am",
        "6:00am",
        "7:00am",
        "8:00am",
        "9:00am",
        "10:00am",
        "11:00am",
        "12:00pm",
        "1:00pm",
        "2:00pm",
        "3:00pm",
        "4:00pm",
        "5:00pm",
        "6:00pm",
        "7:00pm",
        "8:00pm",
        "9:00pm",
        "10:00pm",
        "11:00pm",
      ],
      titleForm: "New Service Item",
      serviceID: "",
      newServiceItem: "",
      newType: "",
      newScheduledTime: [],
      newProvider: "",
      newLOA: "",
      newDays: [],
      rights: [],
      newDescription: "",
      newInstructions: "",
      newStartDate: moment(new Date()).format("YYYY-MM-DD"),
      newEndDate: moment(new Date()).add(1, "Year").format("YYYY-MM-DD"),
      newActive: "",
      editedIndex: -1,
      editedItem: {
        serviceItem: "",
        type: "",
        scheduledTime: [],
        supportStrategy: "",
        strategy: "",
        provider: "",
        loa: "",
        days: [],
        description: "",
        instructions: "",
        startDate: "",
        endDate: "",
        active: "",
      },
      defaultItem: {
        serviceItem: "",
        type: "",
        scheduledTime: [],
        supportStrategy: "",
        strategy: "",
        provider: "",
        loa: "",
        days: [],
        description: "",
        instructions: "",
        startDate: "",
        endDate: "",
        active: "",
      },
      isLoading: true,
      requiredField: [(v) => !!v || "This is required"],
      requiredList: [(v) => v.length > 0 || "This is required"],
      serviceItemDialog: false,
      newServiceItemAdd: "",
    };
  },

  computed: {
    ...mapGetters(["getUserTimezone", "getDefaultTz"]),
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },

    related() {
      let title = "Is this related to the";
      let state = this.$store.state.users.user.State === "Nevada";
      return {
        title: state ? `${title} HAB plan?` : `${title} Support Strategy?`,
        state: state ? true : false,
      };
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  async created() {
    this.getServices();
    this.getRights();
    this.getServiceItem();
    this.getSupportStrategies();
    this.getHabs();
  },

  methods: {
    initialize() {
      this.services = [];
    },
    validate() {
      return this.$refs.form.validate();
    },
    validateReset() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.reset();
      }
    },
    viewService(item) {
      // this.titleForm = "Viewing Service Item";
      // this.dialog = true;
      // this.editService = true;
      // this.newService = false;
      // this.newServiceItem = item.ServiceItem;
      // this.supportStrategy = item.Support;
      // this.strategy = item.Strategy;
      // this.HRC = item.Right;
      // this.restriction = item.HumanRights;
      // this.newType = item.Type;
      // this.newScheduledTime = item.ScheduledTime;
      // this.newProvider = item.Provider;
      // this.newLOA = item.LOA;
      // this.newDays = item.Days;
      // this.newDescription = item.Description;
      // this.newInstructions = item.Instructions;
      // this.newStartDate = moment(item.StartDate).format("YYYY-MM-DD"); //display vaiid date in datepicker
      // this.newEndDate = moment(item.EndDate).format("YYYY-MM-DD");
      // this.newActive = item.Active;
      // this.serviceID = item._id;

      this.$router.push({
        path: `/servicePlan/${this.clientID}/edit`,
        query: { id: item._id, new: true },
      });
    },
    showAdd() {
      // this.newStartDate = tz(new Date(), this.userTimezone).format("YYYY-MM-DD")
      // this.newEndDate = tz(new Date(), this.userTimezone).format("YYYY-MM-DD")
      // this.newStartDate = ""
      // this.newEndDate = ""

      // this.titleForm = "New Service Plan";
      // this.newService = true;
      // this.editService = false;

      this.$router.push({
        path: `/servicePlan/${this.clientID}/add`,
      });
    },

    deleteService(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this service item?") &&
        this.serviceDelete(id);
    },

    serviceDelete(id) {
      axios.delete(`${url}/ServicePlans/${id}`).then((response) => {
        this.getServices();
        if (response.status == 400) {
          response.json().then(function (data) {
            return data.msg;
          });
        }
        this.msg = true;
        this.text = "The service item has been deleted successfully.";
      });
    },

    close() {
      this.dialog = false;
      this.clearFields();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    updateService() {
      if (this.strategy == undefined) {
        var req_body = {
          ServiceItem: this.newServiceItem,
          Type: this.newType,
          ScheduledTime: this.newScheduledTime,
          Right: this.HRC,
          HumanRights: this.restriction,
          Provider: this.newProvider,
          LOA: this.newLOA,
          Days: this.newDays,
          Description: this.newDescription,
          Instructions: this.newInstructions,
          StartDate: this.newStartDate,
          EndDate: this.newEndDate,
          Active: this.newActive,
        };

        axios
          .put(`${url}/ServicePlans/${this.serviceID}`, req_body)
          .then((response) => {
            this.getServices();
            if (response.status == 400) {
              response.json().then(function (data) {
                alert(data.msg);
              });
            }
            this.clearFields();
            this.msg = true;
            this.text = "The service item has been updated successfully.";
          });
        this.close();
      } else {
        var req_body = {
          ServiceItem: this.newServiceItem,
          Type: this.newType,
          ScheduledTime: this.newScheduledTime,
          Support: this.supportStrategy,
          Strategy: this.strategy.Goal,
          SupportStrategy: this.strategy._id,
          Right: this.HRC,
          HumanRights: this.restriction,
          Provider: this.newProvider,
          LOA: this.newLOA,
          Days: this.newDays,
          Description: this.newDescription,
          Instructions: this.newInstructions,
          StartDate: this.newStartDate,
          EndDate: this.newEndDate,
          Active: this.newActive,
        };

        axios
          .put(`${url}/ServicePlans/${this.serviceID}`, req_body)
          .then((response) => {
            this.getServices();
            if (response.status == 400) {
              response.json().then(function (data) {
                alert(data.msg);
              });
            }
            this.clearFields();
            this.msg = true;
            this.text = "The service item has been updated successfully.";
          });
        this.close();
      }
    },
    getServices: function () {
      this.isLoading = true;
      axios
        .get(`${url}/ServicePlans/client/${this.clientID}`)
        .then((res) => {
          this.services = [];
          this.disabledServices = [];
          this.tempServices = res.data.services;

          for (var k = 0; k < this.tempServices.length; k++) {
            // this.tempServices[k].StartDate =
            // this.tempServices[k].StartDate != "" ? moment(this.tempServices[k].StartDate).format("MM-DD-YYYY"): '';

            if (this.tempServices[k].Active == "Active") {
              this.services.push(this.tempServices[k]);
            }

            if (this.tempServices[k].Active == "Disabled") {
              this.disabledServices.push(this.tempServices[k]);
            }
          }
        })
        .finally(() => (this.isLoading = false));
    },

    addService: function () {
      if (this.validate()) {
        if (this.restriction == "") {
          var req_body = {
            ServiceItem: this.newServiceItem,
            Type: this.newType,
            ScheduledTime: this.newScheduledTime,
            Support: this.supportStrategy,
            Strategy: this.strategy.Goal,
            SupportStrategy: this.strategy._id,
            Right: this.HRC,
            Provider: this.newProvider,
            LOA: this.newLOA,
            Days: this.newDays,
            Description: this.newDescription,
            Instructions: this.newInstructions,
            StartDate: this.newStartDate,
            EndDate: this.newEndDate,
            Active: this.newActive,
            ClientID: this.clientID,
          };
        } else {
          req_body = {
            ServiceItem: this.newServiceItem,
            Type: this.newType,
            ScheduledTime: this.newScheduledTime,
            Support: this.supportStrategy,
            Strategy: this.strategy.Goal,
            SupportStrategy: this.strategy._id,
            Right: this.HRC,
            HumanRights: this.restriction,
            Provider: this.newProvider,
            LOA: this.newLOA,
            Days: this.newDays,
            Description: this.newDescription,
            Instructions: this.newInstructions,
            StartDate: this.newStartDate,
            EndDate: this.newEndDate,
            Active: this.newActive,
            ClientID: this.clientID,
          };
        }

        if (this.newServiceItem === "Add New Item") {
          this.newServiceItem = "";
          return;
        }

        axios.post(`${url}/ServicePlans`, req_body).then((res) => {
          this.getServices();
          if (res.status == 400) {
            res.json().then(function (data) {
              this.text = data.msg;
            });
          }
          this.clearFields();
          this.msg = true;
          this.text = "The new service item has been added successfully.";
        });
        this.close();
      }
      this.msg = true;
      this.text = "Please fill out all required fields";
    },

    getServiceItem() {
      axios.get(`${url}/ServicePlans/serviceItem`).then((res) => {
        (this.serviceItems = []),
          res.data.items.forEach((value) => {
            this.serviceItems.push(value.Name);
          });
      });
    },

    createServiceItem() {
      if (this.newServiceItem == "Add New Item") {
        this.newServiceItemAdd = "";
        this.serviceItemDialog = true;
      }
    },

    showServiceItemDialog() {
      this.newServiceItemAdd = this.serviceItemDialog = true;
    },

    addServiceItem() {
      var req_body = {
        Name: this.newServiceItemAdd,
      };
      if (
        !this.newServiceItemAdd === "" ||
        !this.newServiceItemAdd === undefined ||
        !this.serviceItems.some((data) => data === this.newServiceItemAdd)
      ) {
        axios.post(`${url}/ServicePlans/serviceItem`, req_body).then((res) => {
          this.newServiceItem = this.newServiceItemAdd;
          this.getServiceItem();
        });
        this.serviceItemDialog = false;
        this.msg = true;
        this.text = "Item has been added successfully.";
      } else {
        this.msg = true;
        this.text = "Service Item already exist";
      }
    },

    clearFields() {
      this.newServiceItem = "";
      this.newType = "";
      this.newScheduledTime = [];
      this.strategy = "";
      this.supportStrategy = "";
      this.HRC = "";
      this.restriction = "";
      this.newProvider = "";
      this.newLOA = "";
      this.newDays = [];
      this.newDescription = "";
      this.newInstructions = "";
      this.newStartDate = moment(new Date()).format("YYYY-MM-DD");
      this.newEndDate = moment(new Date()).format("YYYY-MM-DD");
      this.newActive = "";
    },

    getSupportStrategies() {
      axios.get(`${url}/support/${this.clientID}`).then((res) => {
        this.strategies = res.data.supports;
      });
    },

    getRights: function () {
      this.isLoading = true;
      axios.get(`${url}/rights/status/${this.clientID}`).then((res) => {
        this.rights = res.data.rights;
      });
    },

    updateRightsData(restriction) {
      this.newDescription = restriction.Justification;
    },
    async getHabs() {
      axios.get(`${url}/hab/plan/${this.clientID}`).then((res) => {
        this.habs = res.data.habs;
      });
    },
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}
</style>
